import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["displayTotalAvatarCount", "offset", "hasMoreHref", "lookup", "maxAvatars", "size", "totalAvatarCountColor", "truncateAvatarListInTooltip"];
import I18n from 'I18n';
import { useMemo } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Text } from 'foundations-components/components/Text';
import { useTheme } from 'foundations-theming/utils';
import { pickToolTipName } from '../lib/displayUtils';
import { AVATAR_LIST_SIZES_MARGIN_OFFSET } from '../Constants';
import { AvatarContentWrapper } from './components/AvatarContentWrapper';
import { AvatarContainer } from './components/AvatarContainer';
import { TextSvg } from './defaultSvgIcons/TextSvg';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const TEXT_SIZE_MAP = {
  xxs: 'detail-100',
  xs: 'body-100',
  sm: 'body-200',
  md: 'body-400',
  lg: 'body-700',
  xl: 'display-200',
  responsive: null
};
export const MoreResultsIndicator = _ref => {
  let {
      displayTotalAvatarCount = false,
      offset,
      hasMoreHref,
      lookup,
      maxAvatars,
      size,
      totalAvatarCountColor,
      truncateAvatarListInTooltip
    } = _ref,
    passThruProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const generatedProps = useMemo(() => {
    const offsetMax = maxAvatars + offset;
    const remainingAvatarsNumber = lookup.length - offsetMax;
    const remainingAvatarsNumberLimit = remainingAvatarsNumber > 9 ? 9 : remainingAvatarsNumber;
    const remainingAvatars = lookup.slice(offsetMax, offsetMax + 9);
    const hasMoreAvatarDisplay = remainingAvatarsNumber ? '+' : '';
    let tooltipTitle = remainingAvatars.map(pickToolTipName).join(', ');
    if ((displayTotalAvatarCount || truncateAvatarListInTooltip) && remainingAvatars.length < remainingAvatarsNumber) {
      // i18n-lint-disable-next-line require-i18n-message
      tooltipTitle = I18n.text('uiAddonAvatars.tooltip.hasMore', {
        list: tooltipTitle
      });
    }
    return {
      displayName: `${remainingAvatarsNumberLimit}${hasMoreAvatarDisplay}`,
      remainingAvatarsNumber: I18n.formatNumber(remainingAvatarsNumber),
      tooltipTitle
    };
  }, [displayTotalAvatarCount, lookup, maxAvatars, offset, truncateAvatarListInTooltip]);
  if (displayTotalAvatarCount) {
    return /*#__PURE__*/_jsx(Flex, {
      flexGrow: 1,
      alignItems: "center",
      justifyContent: "start",
      marginInlineStart: "100",
      children: /*#__PURE__*/_jsx(Tooltip, {
        title: generatedProps.tooltipTitle,
        "data-test-id": "TotalResults-tooltip",
        children: /*#__PURE__*/_jsxs(Text, {
          typography: TEXT_SIZE_MAP[size] || 'body-100',
          color: totalAvatarCountColor,
          children: ["+", generatedProps.remainingAvatarsNumber]
        })
      })
    });
  }
  const marginInlineStart = AVATAR_LIST_SIZES_MARGIN_OFFSET[size];
  return /*#__PURE__*/_jsx(AvatarContainer, {
    isTooltipLoaded: true,
    showTooltip: true,
    tooltipTitle: generatedProps.tooltipTitle,
    marginInlineStart: marginInlineStart,
    borderColor: passThruProps.borderColor,
    borderWidth: passThruProps.borderWidth,
    borderStyle: passThruProps.borderStyle,
    size: size,
    children: /*#__PURE__*/_jsx(AvatarContentWrapper, {
      iconColor: theme.color['text-core-default'],
      size: size,
      href: hasMoreHref,
      backgroundColor: theme.color['fill-surface-default'],
      children: /*#__PURE__*/_jsx(TextSvg, {
        fontSize: "340%",
        children: generatedProps.displayName
      })
    })
  });
};